import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { CurrencyDollar, CaretDown, CaretUp } from "@phosphor-icons/react";

const FIELDS = [
  ["seat_price", "Seat price (headline)", "$20"],
  ["seat_unit", "Seat unit label", "per student · per school year"],
  ["seat_note", "Seat note", "Special package pricing available…"],
  ["workshop_price", "Workshop price", "$500"],
  ["workshop_detail", "Workshop detail", "per workshop — first 2 hours…"],
  ["local_price", "Local training price", "$250"],
  ["local_detail", "Local training detail", "per teacher, per day…"],
];

export const SchoolsPricingCard = () => {
  const [open, setOpen] = useState(false);
  const [vals, setVals] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open && !vals) api.get("/site/schools-pricing").then(({ data }) => setVals(data)).catch(() => {});
  }, [open, vals]);

  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/site/schools-pricing", vals); toast.success("Schools page pricing saved"); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-[#C4C8CE] bg-white p-3 mb-4" data-testid="schools-pricing-card">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between" data-testid="schools-pricing-toggle">
        <span className="flex items-center gap-2 font-display font-bold text-sm">
          <CurrencyDollar size={17} weight="duotone" color="#84CC16" /> Schools page pricing
        </span>
        {open ? <CaretUp size={14} /> : <CaretDown size={14} />}
      </button>
      {open && (
        <div className="mt-3">
          <p className="text-xs text-[#52525B] mb-3 m-0">Shown publicly on selfagency.ca/schools. Edits go live immediately.</p>
          {!vals ? <div className="text-sm text-[#71717A]">Loading…</div> : (
            <div className="flex flex-col gap-2">
              {FIELDS.map(([k, label, ph]) => (
                <label key={k} className="text-xs text-[#52525B]">
                  {label}
                  <input data-testid={`pricing-${k}`} className="input-base w-full mt-0.5" placeholder={ph}
                    value={vals[k] || ""} onChange={(e) => setVals((v) => ({ ...v, [k]: e.target.value }))} />
                </label>
              ))}
              <button data-testid="pricing-save" onClick={save} disabled={busy}
                className="btn-primary w-full mt-1 disabled:opacity-50">{busy ? "Saving…" : "Save pricing"}</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
